// extracted by mini-css-extract-plugin
export var deleteIcon = "_tq-5";
export var deleteOption = "_tq-3";
export var divider = "_tq-2";
export var downloadIcon = "_tq-4";
export var drawer = "_tq-0";
export var drawerFooter = "_tq-6";
export var drawerOpen = "_tq-1";
export var highlighted = "_tq-7";
export var lighterHighlight = "_tq-8";